export default __webpack_public_path__ + "static/media/illustration-study-1-n-m@3x.3c4b8b94.webp";